document.addEventListener("DOMContentLoaded", function () {
  const mapTarget = document.querySelector("#map");

  if (!mapTarget) {
    return;
  }

  const mapItems = [];

  function collectMapData(data, id) {
    const positionText = data.querySelector(".geolocation-latlng").textContent;
    const position = positionText.split(",").map((e) => parseFloat(e));
    const address = data.querySelector(".location-title").textContent;
    const title = data.querySelector(".location-subtitle").textContent;
    const imageSrc = data.querySelector(
      ".location-top-right .marker-img img"
    ).src;
    const directionsLink = data.querySelector(
      ".location-button a.get-direction"
    ).href;
    const streetViewLink = data.querySelector(
      ".location-button a.get-direction-3d"
    ).href;
    const markerId = "marker-" + id;

    const locationData = {
      position,
      address,
      title,
      imageSrc,
      directionsLink,
      streetViewLink,
      markerId,
    };

    return locationData;
  }

  const map = new google.maps.Map(mapTarget, {
    zoom: 14,
    center: new google.maps.LatLng(37.5, -122),
    disableDefaultUI: true,
    mapTypeId: "roadmap",
    gestureHandling: "cooperative",
  });

  const locationDOMs = Array.from(document.querySelectorAll(".location-wrapper"));

  const allLocationsData = locationDOMs.map(collectMapData);

  allLocationsData.forEach((location) => {
    const position = { lat: location.position[0], lng: location.position[1] };

    const contentString = `
            <div class="location-popup-container" id="${location.markerId}">
                <div class="location-popup-left">
                    <div class="location-address-title">${location.address}</div>
                    <div class="location-subtitle">${location.title}</div>
                    <div class="location-links">
                    <a class="location-map-link" href="${location.directionsLink}" target="_blank">
                    <svg width="60" height="60" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 50"><defs><style>.cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}.cls-3{fill:url(#linear-gradient-2);}</style><linearGradient id="linear-gradient" x1="-32.43" y1="94.72" x2="-33.43" y2="95.31" gradientTransform="matrix(50, 0, 0, -50, 1672, 4776)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#f42853"/><stop offset="1" stop-color="#fb5151"/></linearGradient><linearGradient id="linear-gradient-2" x1="-29.63" y1="92.32" x2="-30.63" y2="92.91" gradientTransform="matrix(8.33, 0, 0, -8.33, 276.17, 791)" xlink:href="#linear-gradient"/></defs><title>pin-round</title><g id="pinRound"><path id="base" class="cls-1" d="M25,0h0A25,25,0,0,1,50,25h0A25,25,0,0,1,25,50h0A25,25,0,0,1,0,25H0A25,25,0,0,1,25,0Z"/><path id="pin" class="cls-2" d="M27.08,40.26a2.5,2.5,0,0,1-4.16,0Q13.33,25.84,13.33,20a11.67,11.67,0,0,1,23.33,0Q36.67,25.84,27.08,40.26Z"/><circle id="path-2" class="cls-3" cx="25" cy="19.17" r="4.17"/></g></svg>
                    </a>
                    <a class="location-stretview-link" href="${location.streetViewLink}" target="_blank">
                    <?xml version="1.0" encoding="utf-8"?> <!-- Generator: Adobe Illustrator 21.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --> <svg width="60" height="60" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 60 60" enable-background="new 0 0 60 60" xml:space="preserve"> <g id="icon3d"> <linearGradient id="path-2_2_" gradientUnits="userSpaceOnUse" x1="-28.9949" y1="98.5907" x2="-27.9949" y2="98.037" gradientTransform="matrix(60 0 0 -60 1740 5929)"> <stop  offset="0" style="stop-color:#3664DC"/> <stop  offset="1" style="stop-color:#2B52D1"/> </linearGradient> <path id="path-2_1_" fill="url(#path-2_2_)" d="M30,0L30,0c16.6,0,30,13.4,30,30l0,0c0,16.6-13.4,30-30,30l0,0C13.4,60,0,46.6,0,30 l0,0C0,13.4,13.4,0,30,0z"/> <path id="_x33_D" fill="#FFFFFF" d="M23.3,29.8c1.2,0.3,2.1,0.9,2.7,1.7s0.9,1.8,0.9,3.1c0,1.7-0.6,3-1.9,4c-1.3,1-3,1.5-5.1,1.5 c-1.2,0-2.4-0.2-3.5-0.6c-1.1-0.4-2.1-0.9-2.9-1.6c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.4,0.1-0.8,0.4-1c0.2-0.3,0.5-0.4,0.8-0.4 c0.2,0,0.4,0,0.5,0.1s0.4,0.2,0.6,0.3c0.8,0.5,1.5,0.9,2.2,1.2c0.7,0.3,1.5,0.4,2.3,0.4c1.2,0,2.2-0.2,2.8-0.7s0.9-1.2,0.9-2.2 c0-1-0.3-1.7-0.9-2.2c-0.6-0.5-1.6-0.7-2.9-0.7h-1.6c-0.4,0-0.8-0.1-1-0.4c-0.2-0.3-0.4-0.6-0.4-1c0-0.4,0.1-0.7,0.4-1 c0.2-0.3,0.6-0.4,1-0.4h1.1c2.6,0,3.9-1,3.9-2.9c0-0.9-0.3-1.6-0.8-2c-0.5-0.5-1.3-0.7-2.2-0.7c-1.4,0-2.8,0.5-4.4,1.6 c-0.3,0.1-0.5,0.3-0.6,0.3c-0.1,0.1-0.3,0.1-0.5,0.1c-0.3,0-0.6-0.1-0.8-0.4s-0.4-0.6-0.4-1c0-0.3,0.1-0.5,0.2-0.7 c0.1-0.2,0.3-0.4,0.5-0.6c0.8-0.6,1.7-1.2,2.8-1.5S19,20,20.1,20c1.9,0,3.5,0.5,4.7,1.4s1.7,2.2,1.7,3.8c0,1.1-0.3,2-0.9,2.8 C25.1,28.8,24.3,29.4,23.3,29.8z M32.8,40c-0.6,0-1-0.2-1.3-0.5c-0.3-0.3-0.5-0.7-0.5-1.3V21.7c0-0.5,0.2-1,0.5-1.3 c0.3-0.3,0.8-0.5,1.3-0.5h5.7c3.3,0,5.9,0.9,7.7,2.6S49,26.8,49,30c0,3.2-0.9,5.6-2.8,7.4c-1.8,1.7-4.4,2.6-7.7,2.6H32.8z M38.4,37 c4.4,0,6.6-2.3,6.6-7c0-4.7-2.2-7-6.6-7H35v14H38.4z"/> </g> </svg>
                    </a>
                    </div>
                </div>
                <div class="location-popup-right">
                    <div class="location-image">
                        <img src="${location.imageSrc}" alt="">
                    </div>
                </div>
            </div>
        `;

    const infowindow = new google.maps.InfoWindow({
      content: contentString,
      markerId: location.markerId,
    });

    const marker = new google.maps.Marker({
      position: position,
      markerId: location.markerId,
      map: map,
      zoomControl: true,
      title: location.title,
      icon: {
        url: "/themes/blazingsaddles/css/svgs/location.svg",
        anchor: new google.maps.Point(39, 14),
        scaledSize: new google.maps.Size(50, 50),
      },
    });

    marker.addListener("click", function () {
      mapItems.forEach((mapItem) => {
        mapItem.infowindow.close();
      });
      infowindow.open(map, marker);
      map.panTo(marker.position);
    });

    const mapItem = { infowindow, marker };
    mapItems.push(mapItem);
  });

  const bounds = new google.maps.LatLngBounds();

  if (mapItems.length === 1) {
    // If only one marker, center map on it and set a default zoom level
    map.setCenter(mapItems[0].marker.getPosition());
    map.setZoom(14); // You can adjust this zoom level as needed
  } else {
    // If multiple markers, fit bounds to include all markers
    for (let i = 0; i < mapItems.length; i++) {
      bounds.extend(mapItems[i].marker.getPosition());
    }
    map.fitBounds(bounds);
  }

  locationDOMs.forEach((locationDOM) => {
    locationDOM.addEventListener("click", () => {
      const infoWindowToOpen = mapItems.filter(
        (mapItem) => mapItem.infowindow.markerId === locationDOM.id
      )[0];
      mapItems.forEach((mapItem) => {
        mapItem.infowindow.close();
      });
      infoWindowToOpen.infowindow.open(map, infoWindowToOpen.marker);
    });
  });

  const zoomInButton = document.querySelector("#maps-zoom-in-button");
  const zoomOutButton = document.querySelector("#maps-zoom-out-button");

  google.maps.event.addDomListener(zoomInButton, "click", function () {
    map.setZoom(map.getZoom() + 1);
  });

  google.maps.event.addDomListener(zoomOutButton, "click", function () {
    map.setZoom(map.getZoom() - 1);
  });
});
